import * as types from './types';

export const init = () => ({
  type: types.INIT,
});

export const onExpandEvent = (event: string, toggle = true) => ({
  type: types.ON_EXPAND_EVENT,
  event,
  toggle,
});

export const highlightMomentByEvent = (event: string, timestamp: number) => ({
  type: types.HIGHLIGHT_MOMENT_BY_EVENT,
  event,
  timestamp,
});

export const removeHighlightByEvent = (event: string) => ({
  type: types.REMOVE_HIGHLIGHT_BY_EVENT,
  event,
});
